import { useMemo } from 'react';
import { useMatches } from 'react-router';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const schema = z.object({
  DisplayPreferences: z.function().returns(z.any()),
});

export function DisplayPreferences() {
  const matches = useMatches();

  const RouteDisplayPreferences = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.DisplayPreferences;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteDisplayPreferences === undefined) {
    return null;
  }

  return (
    <div>
      <RouteDisplayPreferences />
    </div>
  );
}
